// src/hooks/usePush.js — Hook para notificaciones push con Firebase FCM
import { useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey:            "AIzaSyB_GbQbKmtfPLWODTOafhiUduIL5dabMHI",
  authDomain:        "turival-9f82d.firebaseapp.com",
  projectId:         "turival-9f82d",
  storageBucket:     "turival-9f82d.firebasestorage.app",
  messagingSenderId: "1041282512308",
  appId:             "1:1041282512308:web:a1b4cc1855313713c36ee1",
};

const VAPID_KEY = "BEF1y8jlUxYF4cHQ_GOPMlgWHUJlcKysy_QIGI_YKL85WC2KkGprG8nl5j2QoeHZWyKVRFWp1LafLhTvcTC2pug";
const API       = process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000';

let firebaseApp;
let messaging;

function getFirebaseMessaging() {
  if (!firebaseApp) {
    firebaseApp = initializeApp(firebaseConfig);
    messaging   = getMessaging(firebaseApp);
  }
  return messaging;
}

async function registrarTokenPush(usuarioId) {
  try {
    if (!('Notification' in window)) return;
    if (!('serviceWorker' in navigator)) return;

    const permiso = await Notification.requestPermission();
    if (permiso !== 'granted') return;

    const sw = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    const msg = getFirebaseMessaging();

    const token = await getToken(msg, {
      vapidKey:          VAPID_KEY,
      serviceWorkerRegistration: sw,
    });

    if (!token) return;

    // Guardar token en backend
    await fetch(`${API}/api/push/token`, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({
        usuario_id: usuarioId,
        token,
        plataforma: 'web',
      }),
    });

    console.log('[Push] Token registrado correctamente');
    return token;
  } catch (err) {
    console.warn('[Push] Error registrando token:', err.message);
  }
}

export function usePush(usuario) {
  useEffect(() => {
    if (!usuario?.id) return;

    // Registrar token
    registrarTokenPush(usuario.id);

    // Manejar mensajes en foreground
    try {
      const msg = getFirebaseMessaging();
      const unsub = onMessage(msg, payload => {
        const { title, body } = payload.notification || {};
        if (!title) return;
        // Mostrar notificación nativa si la app está en foreground
        if (Notification.permission === 'granted') {
          new Notification(title, {
            body,
            icon:  '/logo192.png',
            badge: '/logo192.png',
          });
        }
      });
      return () => unsub();
    } catch (err) {
      console.warn('[Push] Error en onMessage:', err.message);
    }
  }, [usuario?.id]);
}
